import { useTranslation } from "next-i18next";

const useApplicationTranslation = () => {
  return useTranslation<"application">("application");
};

export default useApplicationTranslation;
